export default __webpack_public_path__ + "static/media/bg.4e7f0c1e.png";